import ASplitButton from './index.vue';

ASplitButton.install = app => {
  app.component(ASplitButton.name, ASplitButton);
};

export default ASplitButton;
